import { getCurrentUser } from '../data/auth.js';

export function normalizeCommunityComments(list = []) {
    return (list || [])
        .filter((c) => !c.hidden)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export function buildCommentTree(comments) {
    const roots = [];
    const byId = new Map();
    comments.forEach((c) => {
        const node = { ...c, replies: [] };
        byId.set(c.id, node);
    });
    comments.forEach((c) => {
        const node = byId.get(c.id);
        if (c.parentId && byId.has(c.parentId)) {
            byId.get(c.parentId).replies.push(node);
        } else if (!c.parentId) {
            roots.push(node);
        }
    });
    return roots;
}

export function renderCommunityCommentsHtml(project, fund, { canModerate = false } = {}) {
    const visible = normalizeCommunityComments(project.communityComments);
    const tree = buildCommentTree(visible);
    const user = getCurrentUser();

    const renderNode = (node, depth = 0) => {
        const flagBtn = user && !canModerate
            ? `<button type="button" class="fg-fund-btn fg-fund-btn--ghost fg-flag-btn" data-flag-id="${node.id}">Flag</button>`
            : '';
        const delBtn = canModerate
            ? `<button type="button" class="fg-fund-btn fg-fund-btn--danger-text" data-delete-comment="${node.id}">Delete</button>`
            : '';
        const replies = node.replies?.map((r) => renderNode(r, 1)).join('') || '';
        return `
            <div class="fg-fund-community-comment ${depth ? 'fg-fund-community-comment--reply' : ''}" data-comment-id="${node.id}">
                <div class="fg-fund-community-comment__head">
                    <strong>${escapeHtml(node.userName || 'User')}</strong>
                    <time>${node.date || ''}</time>
                </div>
                <p>${escapeHtml(node.body)}</p>
                <div class="fg-fund-community-comment__actions">${flagBtn}${delBtn}</div>
                ${replies}
            </div>`;
    };

    const listHtml = tree.length
        ? tree.map((n) => renderNode(n)).join('')
        : `<p class="fg-fund-empty-sub">${fund.tr('noCommentsYet')}</p>`;

    const formHtml = user
        ? `<form id="community-comment-form" class="fg-fund-form">
            <textarea id="community-comment-body" class="fg-textarea" placeholder="${fund.tr('writeComment')}" required maxlength="500"></textarea>
            <button type="submit" class="fg-fund-btn fg-fund-btn--primary">${fund.tr('postComment')}</button>
           </form>`
        : `<p class="fg-fund-empty-sub">${fund.tr('signInToComment')}</p>`;

    return `${formHtml}<div class="fg-fund-community-list">${listHtml}</div>`;
}

export function createCommentPayload(body, parentId = null) {
    const user = getCurrentUser();
    const now = new Date();
    return {
        id: `cmt-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        userId: user?.uid || 'anon',
        userName: user?.email?.split('@')[0] || 'User',
        body: String(body).trim(),
        parentId: parentId || null,
        flags: 0,
        hidden: false,
        createdAt: now.toISOString(),
        date: now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    };
}

function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
